import React from "react";
import { Link } from "react-router-dom";
import {
  CLIENT_SSO_COLLECTION_BUILD_PATH,
  CLIENT_SSO_IMAGE_GENERATOR_PATH,
} from "../../constants/clientSso";

type Props = {
  isSidebarOpen: boolean;
};

const GenerativePlatform: React.FC<Props> = ({ isSidebarOpen }) => {
  return (
    <div
      className={`${!isSidebarOpen ? "w-[calc(100vw-265px)]" : "w-[calc(100vw-105px)]"} fixed transition-all duration-500 ease-in-out overflow-y-scroll h-[calc(100vh-80px)] ml-1 px-6 py-5 font-avenir`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-primary">
            Generative Feature
          </h1>
          <p className="text-sm text-secondary mt-1">
            Choose Image Generator or Collection Build to continue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link
            to={CLIENT_SSO_IMAGE_GENERATOR_PATH}
            className="bg-white rounded-2xl border border-light p-6 hover:bg-gray transition-colors"
          >
            <h2 className="text-lg font-semibold text-primary mb-2">
              Image Generator
            </h2>
            <p className="text-sm text-secondary">
              Create generative images from a prompt.
            </p>
          </Link>
          <Link
            to={CLIENT_SSO_COLLECTION_BUILD_PATH}
            className="bg-white rounded-2xl border border-light p-6 hover:bg-gray transition-colors"
          >
            <h2 className="text-lg font-semibold text-primary mb-2">
              Collection Build
            </h2>
            <p className="text-sm text-secondary">
              Query seasonal reports and build a collection brief.
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GenerativePlatform;
